import { createSlice, PayloadAction } from "redux-starter-kit";

interface FilterState {
    // Known filters
    view?: string;
    // Everything else
    [key: string]: any;
}
export interface FeedFiltersSlice {
    pending: FilterState;
    active: FilterState;
    showFeedDescription: boolean;
    showBreadcrumbs: boolean;
    title: string | null;
}

// Split into pending and active filters.
const initialState: FeedFiltersSlice = {
    pending: {},
    active: {},
    showFeedDescription: true,
    showBreadcrumbs: true,
    title: null,
};
const feedFilters = createSlice({
    slice: "feedFilters",
    initialState,
    reducers: {
        setActiveFilters(state, action: PayloadAction<FilterState>): void {
            // State can be modified directly when inside createSlice
            state.active = action.payload;
        },
        setPendingFilters(state, action: PayloadAction<FilterState>): void {
            state.pending = action.payload;
        },
        clearFilters(state): FeedFiltersSlice {
            state = initialState;
            return state;
        },
        setFeedOrder(state, action: PayloadAction<string>): void {
            state.active.view = action.payload;
        },
        clearActiveFilters(state): void {
            state.active = initialState.active;
        },
        clearPendingFilters(state): void {
            state.pending = initialState.pending;
        },
        hideFeedDescription(state): void {
            state.showFeedDescription = false;
        },
        hideBreadcrumbs(state): void {
            state.showBreadcrumbs = false;
        },
        setTitle(state, action: PayloadAction<string>): void {
            state.title = action.payload;
        },
    },
});

// Extract the action creators object and the reducer
const { actions, reducer } = feedFilters;
// Extract and export each action creator by name
export const {
    setActiveFilters,
    clearFilters,
    clearActiveFilters,
    clearPendingFilters,
    setFeedOrder,
    hideFeedDescription,
    hideBreadcrumbs,
    setTitle,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
